import { useRef } from 'react';
import { useStickyPosition } from './useStickyPosition';

/**
 * Pins the document outline panel below the editor toolbar while scrolling,
 * matching the panel's floating position/width to its containing column
 * (which the panel itself loses track of once taken out of normal flow).
 */
export function useStickyOutlinePanel(toolbarElementId: string) {
  const tocContainerRef = useRef<HTMLDivElement | null>(null);
  const outlineContainerRef = useRef<HTMLDivElement | null>(null);

  useStickyPosition({
    elementRef: outlineContainerRef,
    boundaryRef: tocContainerRef,
    getStickOffset: () =>
      document.getElementById(toolbarElementId)?.offsetHeight ?? 0,
    onReposition: (isFixed) => {
      const panel = outlineContainerRef.current;
      const boundary = tocContainerRef.current;
      if (!panel) {
        return;
      }
      if (isFixed && boundary) {
        const rect = boundary.getBoundingClientRect();
        const { paddingLeft, paddingRight } = getComputedStyle(boundary);
        panel.style.left = `${rect.left + Number.parseFloat(paddingLeft)}px`;
        panel.style.width = `${
          rect.width -
          Number.parseFloat(paddingLeft) -
          Number.parseFloat(paddingRight)
        }px`;
        panel.style.zIndex = '2';
      } else {
        panel.style.left = '';
        panel.style.width = '';
        panel.style.zIndex = '';
      }
    },
  });

  return { tocContainerRef, outlineContainerRef };
}
